import { defineStore } from 'pinia';

import { getModules as getModulesAPI } from '@/api/module.api';

export const useModuleStore = defineStore('module', {
  state: () => ({
    modules: [],
    isLoading: false,
    lastFetched: null,
  }),

  getters: {
    hasModules: (state) => state.modules.length > 0,
    isCached: (state) => state.modules.length > 0 && state.lastFetched !== null,
  },

  actions: {
    async getModules(force = false) {
      // Return cached modules if available and not forcing refresh
      if (!force && this.hasModules) {
        return this.modules;
      }

      // Prevent concurrent requests
      if (this.isLoading) {
        return this.modules;
      }

      this.isLoading = true;
      try {
        const response = await getModulesAPI();

        // Handle different response formats
        let modulesList = [];
        if (Array.isArray(response)) {
          modulesList = response;
        } else if (response?.data && Array.isArray(response.data)) {
          modulesList = response.data;
        } else if (response?.modules && Array.isArray(response.modules)) {
          modulesList = response.modules;
        }

        this.$patch({
          modules: modulesList,
          lastFetched: new Date().toISOString(),
        });

        return modulesList;
      } catch (error) {
        console.error('Error fetching modules:', error);
        throw error;
      } finally {
        this.isLoading = false;
      }
    },

    // Clear cache (useful for logout or when user changes)
    clearModules() {
      this.$patch({
        modules: [],
        lastFetched: null,
      });
    },
  },
});
